module.exports = __webpack_public_path__ + "static/media/build-manual-app-hero.19a5a196.png";